import React from "react";
import "./styles.css";
import classNames from "classnames";

export function RoomLogo({ className, refs, ...rest }) {
  return (
    <div
      className={classNames("room-logo", className)}
      ref={refs?.logo}
      {...rest}
    >
      <img
        src={process.env.PUBLIC_URL + "images/logo/wall-logo.png"}
        alt="wall-logo"
        ref={refs?.wall}
      />
      <img
        src={process.env.PUBLIC_URL + "images/logo/window-logo.png"}
        alt="window-logo"
        ref={refs?.window}
      />

      <img
        src={process.env.PUBLIC_URL + "images/logo/floor-logo.png"}
        alt="floor-logo"
        ref={refs?.floor}
      />
    </div>
  );
}
